import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

// Importe o validateOrFail do submódulo de CNPJ do validation-br
import { validateOrFail } from 'validation-br/dist/cnpj'

// Crie seu método personalizado chamado cnpj()
function cnpj(this: yup.StringSchema, message: string) {
  return this.test('cnpj', message, function (value?: string) {
    try {
      if (value) validateOrFail(value)
      return true
    } catch (error) {
      // Cria um erro se cair no catch
      return this.createError({
        // Exibe a mensagem do catch
        message: message ?? '',
      })
    }
  })
}

yup.setLocale(pt)

// Adiciona seu método cnpj() ao grupo de strings do yup
yup.addMethod(yup.string, 'cnpj', cnpj)

export default yup
